var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19.932 24.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple_2_1",
    "data-name": "apple (2) 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.608,18.7C2.992,18.681,0,11.3,0,7.539,0,1.4,4.607.052,6.383.052A7.345,7.345,0,0,1,8.791.644a5.383,5.383,0,0,0,1.375.394,4.279,4.279,0,0,0,.987-.32A7.907,7.907,0,0,1,14.127,0h.007a6.1,6.1,0,0,1,5.1,2.576l.372.559-.535.4a4.5,4.5,0,0,0-2.16,3.715,4.193,4.193,0,0,0,2.34,3.876c.335.2.682.41.682.864,0,.3-2.369,6.672-5.81,6.672a4.673,4.673,0,0,1-1.962-.476,3.979,3.979,0,0,0-1.746-.421,4.492,4.492,0,0,0-1.383.374,6.773,6.773,0,0,1-2.4.56Z",
    transform: "translate(0 5.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.565,0C4.655,3.231,2.344,5.473.036,5.332-.344,2.754,2.344,0,4.565,0Z",
    transform: "translate(9.926)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.eed1034073c82536cad2cef07d01ddfc.svg";
export { ForwardRef as ReactComponent };